import { extractValues, mergeConfig } from '../utils/configUtils'
import { fontCheck } from '../utils/fontUtils'
import { getDownloadUrl } from '../utils/exportUtils'
const cloneDeep = require('clone-deep')
class BaseComponent {
  get data() {
    return this._data
  }
  set data(value) {
    this._data = value
    this.viz.data = this.data
  }

  get config() {
    return this._config
  }
  set config(value) {
    let merged = mergeConfig(value, this._getConfig())
    let valid = extractValues(merged)
    this._config = valid
    this.viz.config = this.config
    // this.viz.onAnnotationChange = this.onAnnotationChange
    // this.viz.onAnnotationClick = this.onAnnotationClick
    this.viz.editMode = this.editMode
  }

  constructor($root, data, config) {
    this.$root = $root
    this.viz = new this.__proto__.constructor.vizClass(this.$root)
    this.viz._parent = this
    this.viz.componentLabel = this.__proto__.constructor.componentLabel || 'name_not_found' //this.constructor.name.replace('Component','')

    fontCheck().then(() => {
      this.config = config
      if (data) this.data = data
      // if (this.onReady) this.onReady()
      this.emit('ready', { data: this.data, config: this.config })
    })
  }

  _getConfig() {
    let config = this.constructor.vizClass.prototype._getConfig()
    let result = mergeConfig(this.constructor.defaultConfig, config)
    return cloneDeep(result)
  }

  getSVG() {
    return this.viz.getSVG()
  }
  getSVGURL() {
    return this.getSVG().then(svg => {
      return getDownloadUrl(svg)
    })
  }

  on(eventName, callback) {
    this.addEventListener(eventName, callback)
  }
  addEventListener(eventName, callback) {
    this.eventListeners ||= {}
    this.eventListeners[eventName] ||= []
    this.eventListeners[eventName].push(callback)
  }
  emit(eventName, data) {
    //CUIDAO! me lo he cargado porqeu petaba el treemap, pero seguro se puede/debe recuperar!
    // data = data ? JSON.parse(JSON.stringify(data)) : undefined
    if (this.eventListeners) {
      this.eventListeners[eventName]?.forEach(cb => {
        cb(data)
      })
    }
    let onName = `on${eventName.charAt(0).toUpperCase() + eventName.slice(1)}`
    if (this[onName]) this[onName](data)
  }
  selectById(id) {
    this.viz && this.viz.selectById && this.viz.selectById(id)
  }
  showTooltipById(id) {
    this.viz && this.viz.showTooltipById && this.viz.showTooltipById(id)
  }
}

export default BaseComponent
